import dom from '../../../wrapper/DomWrapper';
import { CART_CLASS, HEADER_LAYOUT_WRAPPER, LOGO_CLASS } from '../constants';

export default (selector) => Array.from(dom.getCollection(`${HEADER_LAYOUT_WRAPPER}`, selector))
  .every((el) => dom.hasClass(el, LOGO_CLASS) || dom.hasClass(el, CART_CLASS));
